/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function GetZoneByIdCameraLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeGetZoneByIdCameraLoadedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const GetZoneByIdCameraLoadedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action: actionsTypesFromStore.TypeGetZoneByIdCameraLoadedAction) => {
          switch (action.type) {
            case actions.GetZoneByIdCameraLoadedActionTypes
                .GETZONEBYIDCAMERALOADED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.GetZoneByIdCameraLoadedActionTypes
                .GETZONEBYIDCAMERALOADED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.GetZoneByIdCameraLoadedActionTypes
                .GETZONEBYIDCAMERALOADED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            case actions.GetZoneByIdCameraLoadedActionTypes
                .GETZONEBYIDCAMERALOADED_RESET:

              return {
                state: {

                }
              }

              break;

            default:
              return state
              break;
          }
        }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/getmaskbyzone/index.ts